export const searchTooltipText = 'Search by task ID and title';
export const deleteConfirmText = 'Are you sure you want to delete the task(s)?';
export const deleteConfirmDescription = 'Deleting the task(s) will remove all associated data, including files and dependencies with other tasks.';
